// extracted by mini-css-extract-plugin
export default {"multiRadio":"uePMAPQ","MktLangSelect":"bHv7SMc"};